import { Box, Container, Heading, VStack } from "@chakra-ui/react";
import UserHandleForm from "../components/UserHandleForm";
import ProfilePictureForm from "../components/ProfilePictureForm";

const Account = () => {
  return (
    <Container>
      <Box width="100%" py="12">
        <VStack spacing="6" alignItems="stretch">
          <Heading as="h2" size="lg" marginBottom="16px">
            My Profile
          </Heading>

          <Box bg="gray.700" borderRadius="lg" p="6">
            <ProfilePictureForm />
            <UserHandleForm />
          </Box>
        </VStack>
      </Box>
    </Container>
  );
};

export default Account;
